import { render } from "./FirstComponent.vue?vue&type=template&id=787c80f6"
import script from "./FirstComponent.vue?vue&type=script&lang=js"
export * from "./FirstComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__